// Static guide roster — ported from the legacy v5.5 artifact.
// 12 seed guides come from the baked data (RAW.guides / _C.g); Sean Golightly is
// pushed separately by the v5.1 roster-reconciliation block (legacy ~line 1189).
// Total = 13 guides. See REBUILD-SPEC.md §1.4.
//
// peekName vs availName divergences are PRESERVED verbatim (the two identities are
// distinct join keys): James/Jamey Hasapis, Revel Lucien/Revelucien,
// Bill Knots/Bill Knotts, Devon Solovey/Devon Elia, Matthew Gore/Monk Gore.
//
// `performanceScore` is null for every guide today (the source omits it; the
// legacy picker always reads it as null). It is set explicitly here to satisfy
// the Guide interface.
//
// Benched guides (excluded from the auto-picker via `inactive:true`) per §1.4:
//   - Revel Lucien (cmau_g4j9a) — left the company
//   - Michelle Le Fevre (cmau_8ed3k) — on leave
// They remain in the roster so Peek-assigned shifts still resolve a name.

import type { Guide } from "@/types";

export const GUIDES: Guide[] = [
  // ---- Flagstaff ----
  {
    id: "cmau_5ej94",
    peekName: "Steve Benning",
    availName: "Steve Benning",
    region: "Flagstaff",
    productIds: [
      "0ced34cb-0eb9-4f59-bc48-f5cb72b72187",
      "1898909d-ba15-436a-8c4f-452945d70f9f",
      "80a1896b-62c1-4d84-a6f4-c8ddf65ff074",
      "b419e3fd-85f0-416d-9018-6a6f5d0426fd",
    ],
    performanceScore: null,
    email: "az_radioman@yahoo.com",
    phone: "+1 928-600-7259",
  },
  {
    id: "cmau_j9yxb",
    peekName: "James Hasapis", // Peek identity
    availName: "Jamey Hasapis", // availability/Notion identity (divergent)
    region: "Flagstaff",
    productIds: [
      "0ced34cb-0eb9-4f59-bc48-f5cb72b72187",
      "1898909d-ba15-436a-8c4f-452945d70f9f",
      "80a1896b-62c1-4d84-a6f4-c8ddf65ff074",
      "b419e3fd-85f0-416d-9018-6a6f5d0426fd",
    ],
    performanceScore: null,
    email: "james.hasapis@gmail.com",
    phone: "+1 928-310-8974",
  },
  {
    id: "cmau_pz3ed",
    peekName: "Mike Miller",
    availName: "Mike Miller",
    region: "Flagstaff",
    productIds: [
      "0ced34cb-0eb9-4f59-bc48-f5cb72b72187",
      "1898909d-ba15-436a-8c4f-452945d70f9f",
      "b419e3fd-85f0-416d-9018-6a6f5d0426fd",
    ],
    performanceScore: null,
    email: "kurganlane@gmail.com",
    phone: "+1 928-853-0981",
  },
  {
    id: "cmau_g4j9a",
    peekName: "Revel Lucien", // Peek identity
    availName: "Revelucien", // availability/Notion identity (divergent)
    region: "Flagstaff",
    productIds: [
      "1898909d-ba15-436a-8c4f-452945d70f9f",
      "80a1896b-62c1-4d84-a6f4-c8ddf65ff074",
    ],
    performanceScore: null,
    email: "revelucien@gmail.com",
    phone: "+1 208-297-8853",
    inactive: true,
    inactiveReason: "Removed 2026-06-16 — no longer with company",
  },
  {
    id: "cmau_8ed3k",
    peekName: "Michelle Le Fevre",
    availName: "Michelle Le Fevre",
    region: "Flagstaff",
    productIds: [
      "0ced34cb-0eb9-4f59-bc48-f5cb72b72187",
      "1898909d-ba15-436a-8c4f-452945d70f9f",
    ],
    performanceScore: null,
    email: "mmlefevre@outlook.com",
    phone: "+1 928-921-0050",
    inactive: true,
    inactiveReason: "On leave",
  },
  {
    // Added by the v5.1 roster reconciliation (legacy ~line 1189): an active
    // Flagstaff Haunted History guide onboarded after the May snapshot.
    id: "cmau_6ejn5",
    peekName: "Sean Golightly",
    availName: "Sean Golightly",
    region: "Flagstaff",
    productIds: ["1898909d-ba15-436a-8c4f-452945d70f9f"],
    performanceScore: null,
    // No email/phone in source — omitted.
  },

  // ---- Prescott ----
  {
    id: "cmau_ebenn",
    peekName: "Stephanie Tatum-Ford",
    availName: "Stephanie Tatum-Ford",
    region: "Prescott",
    productIds: ["8d66ea83-c5af-42ea-90ec-9ba78f05d7f2"],
    performanceScore: null,
    email: "statumford@gmail.com",
    phone: "+1 808-640-9669",
  },
  {
    id: "cmau_mykav",
    peekName: "Shane Harding",
    availName: "Shane Harding",
    region: "Prescott",
    productIds: [
      "0bc9822a-4109-461c-89bf-41ac494c61f7",
      "8d66ea83-c5af-42ea-90ec-9ba78f05d7f2",
    ],
    performanceScore: null,
    email: "shaneharding23@gmail.com",
    phone: "+1 713-819-4769",
  },
  {
    id: "cmau_q3qaj",
    peekName: "Meg Mezeske",
    availName: "Meg Mezeske",
    region: "Prescott",
    productIds: ["8d66ea83-c5af-42ea-90ec-9ba78f05d7f2"],
    performanceScore: null,
    email: "megmezeske@gmail.com",
    phone: "+1 928-221-0130",
  },
  {
    id: "cmau_vn9bj",
    peekName: "Bill Knots", // Peek identity
    availName: "Bill Knotts", // availability/Notion identity (divergent — extra "t")
    region: "Prescott",
    productIds: ["8d66ea83-c5af-42ea-90ec-9ba78f05d7f2"],
    performanceScore: null,
    email: "wmilesk@pm.me",
    phone: "+1 480-695-7930",
  },

  // ---- Tucson ----
  {
    id: "cmau_98gk9",
    peekName: "Devon Solovey", // Peek identity
    availName: "Devon Elia", // availability/Notion identity (divergent)
    region: "Tucson",
    productIds: [
      "2dae269d-e8a0-4afb-a926-0bae94468d37",
      "7c6e9626-35fd-4e72-887a-f8fb29a04cb8",
    ],
    performanceScore: null,
    email: "dev.elia927@gmail.com",
    phone: "+1 520-549-9599",
  },
  {
    // Live Peek id verified 2026-07-09 via operator GET /users (cmau_dkmny is a
    // STALE deleted-account id — do not resurrect it).
    id: "cmau_7jzd9",
    peekName: "Jade Marmorstein",
    availName: "Jade Marmorstein",
    region: "Tucson",
    productIds: [
      "2dae269d-e8a0-4afb-a926-0bae94468d37",
      "7c6e9626-35fd-4e72-887a-f8fb29a04cb8",
    ],
    performanceScore: null,
    email: "jhmarmo@charter.net",
    phone: "+1 520-400-6380",
  },
  {
    id: "cmau_q3q9k",
    peekName: "Matthew Gore", // Peek identity
    availName: "Monk Gore", // availability/Notion identity (divergent)
    region: "Tucson",
    productIds: [
      "2dae269d-e8a0-4afb-a926-0bae94468d37",
      "7c6e9626-35fd-4e72-887a-f8fb29a04cb8",
    ],
    performanceScore: null,
    email: "pietrafolium@gmail.com",
    phone: "+1 520-427-2535",
  },
];

/** Peek accountUserId -> Guide. */
export const guideByPeekId: Record<string, Guide> = Object.fromEntries(
  GUIDES.map((g) => [g.id, g]),
);

/** lowercased peekName -> Guide. */
export const guideByPeekName: Record<string, Guide> = Object.fromEntries(
  GUIDES.map((g) => [g.peekName.toLowerCase(), g]),
);

/** lowercased availName -> Guide. */
export const guideByAvailName: Record<string, Guide> = Object.fromEntries(
  GUIDES.map((g) => [g.availName.toLowerCase(), g]),
);

/**
 * Resolve a guide by EITHER identity (peekName or availName), case-insensitive.
 * peekName wins on the rare chance one name collides with another's availName.
 * Returns null when nothing matches.
 */
export function lookupGuideByAnyName(name: string): Guide | null {
  if (!name) return null;
  const key = name.toLowerCase().trim();
  return guideByPeekName[key] ?? guideByAvailName[key] ?? null;
}
